let _sentry: typeof import("@sentry/react") | null = null;

/** Initialize Sentry lazily after first paint (production only). */
export function initSentryDeferred() {
  if (!import.meta.env.PROD) return;

  const init = () => {
    import("@sentry/react").then((Sentry) => {
      _sentry = Sentry;
      Sentry.init({
        dsn: "https://43c9fc8c140a6eee891979c4e6719159@o1324202.ingest.us.sentry.io/4511140348100608",
        sendDefaultPii: true,
        ignoreErrors: [
          "Java object is gone",
          "enableDidUserTypeOnKeyboardLogging",
          "Failed to update a ServiceWorker",
          "Script https://weddingly.se/sw.js load failed",
          "'text/html' is not a valid JavaScript MIME type.",
          /^TypeError: Internal error$/,
          "Object Not Found Matching Id",
          "webkit.messageHandlers",
          "NotFoundError: The object can not be found here.",
          "Exceeded storage quota",
        ],
      });
    });
  };

  if (typeof requestIdleCallback === "function") {
    requestIdleCallback(init);
  } else {
    setTimeout(init, 1500);
  }
}

/** Safe wrapper — no-ops if Sentry hasn't loaded yet. */
export function setSentryUser(user: { id: string; role: string } | null) {
  _sentry?.setUser(user);
}
